export class SolrError extends Error {
  constructor(message) {
    super(message);
    this.name = 'SolrError';
  }
}
